export default "__VITE_ASSET__605e53b9__"